import { httpRequest } from "../../../utils/HttpRequest";
import { IPurchaseEnquirySearch, IPurchaseEnquiryDetail, IPurchaseEnquiryFields, Detailed, IPurchaseEnquiryList, IPurchaseEnquiryStatistics } from "./purchaseEnquiryType"
class PurchaseEnquiryService {
    async page(searchVo: IPurchaseEnquirySearch) {
        const apiUrl = "/zzw-vrm/purchaseEnquiry/findPage";
        return await httpRequest.post<IPurchaseEnquiryList>(apiUrl, searchVo);
    }
    async total(searchVo: IPurchaseEnquirySearch) {
        const apiUrl = "/zzw-vrm/purchase/enquiry/total";
        return await httpRequest.post<IPurchaseEnquiryStatistics>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/zzw-vrm/purchaseEnquiry/findById/${id}`;
        return await httpRequest.get<IPurchaseEnquiryDetail>(apiUrl);
    }
    async oneSupplier(code: string) {
        const apiUrl = `/zzw-vrm/purchaseOffer/findOfferByCode/${code}`;
        return await httpRequest.get<any>(apiUrl);
    }
    async insert(insertVo: IPurchaseEnquiryFields) {
        const apiUrl = "/zzw-vrm/purchaseEnquiry/insert";
        return await httpRequest.post<IPurchaseEnquiryDetail>(apiUrl, insertVo);
    }
    async update(updateVo: IPurchaseEnquiryFields) {
        const apiUrl = "/zzw-vrm/purchaseEnquiry/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async changeSupplier(updateVo: IPurchaseEnquiryFields) {
        const apiUrl = "/zzw-vrm/purchaseChange/change";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async changeSupplierLog(updateVo: IPurchaseEnquiryFields) {
        const apiUrl = "/zzw-vrm/purchaseChange/findPage";
        return await httpRequest.post<any>(apiUrl, updateVo);
    }
    //明细删除
    async materialDelete(params: Detailed) {
        const apiUrl = "/zzw-vrm/purchase/enquiry/materialDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //导出
    async export(params: IPurchaseEnquirySearch) {
        const apiUrl = "/zzw-vrm/purchaseEnquiry/export";
        return await httpRequest.postFile(apiUrl, params);
    }
    //明细导出
    async exportDetail(code: string) {
        const apiUrl = `/zzw-vrm/purchaseEnquiry/export/${code}`;
        return await httpRequest.postFile(apiUrl, {});
    }
    //轮胎油品明细导出
    async ltFyExport(code: string) {
        const apiUrl = `/zzw-vrm/purchaseEnquiry/ltFyExport/${code}`;
        return await httpRequest.postFile(apiUrl, {});
    }
    //提交
    async submit(id: string) {
        const apiUrl = `/zzw-vrm/purchaseEnquiry/submit/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    //转采购单
    async demo(enquiryCode: string) {
        const apiUrl = `/zzw-vrm/purchase/enquiry/transfer/${enquiryCode}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    async transfer(searchVo: any) {
        const apiUrl = "/zzw-vrm/purchaseEnquiry/approval";
        return await httpRequest.post<IPurchaseEnquiryStatistics>(apiUrl, searchVo);
    }
    // //详情导入
    // async import(){
    //     const apiUrl = "/zzw-vrm/purchase/enquiry/detail/downloadTpl";
    //     return await httpRequest.getFile<boolean>(apiUrl);
    // }
    //下载模板
    async downloadTpl() {
        // const apiUrl = "/zzw-vrm/purchase/enquiry/detail/downloadTpl";
        const apiUrl = "/zzw-vrm/purchase/detail/downloadTpl";
        return await httpRequest.getFile<boolean>(apiUrl);
    }
    //打印次数
    async printNum(id: string) {
        const apiUrl = `/zzw-vrm/purchase/enquiry/print/${id}`;
        return await httpRequest.get(apiUrl);
    }

    async findDetailByCodes(codes: string[]) {
        const apiUrl = "/zzw-vrm/purchaseEnquiry/findDetailByCodes";
        return await httpRequest.post<IPurchaseEnquiryDetail[]>(apiUrl, codes);
    }
}

export const purchaseEnquiryService = new PurchaseEnquiryService();